import {init as shopifyInit} from '../../services/Shopify';
import {shopifyData} from './data';
import {WSProvider} from '../../providers/WebSocketProvider';
import {VideoProvider} from '../../providers/VideoProvider';
import ISRooms from './ISRooms';
import Chat from '../../components/ChatCmp';
import { useEffect } from 'react';
import GACmp from "../../components/GACmp";
import ISMenu from './ISMenu';

const NODE_ENV = process.env.REACT_APP_NODE_ENV;
const TRACKING_ID = process.env.REACT_APP_GA4_TRACKING_ID;
let GA_IS_TI = "";
if (['PROD'].indexOf(NODE_ENV) !== -1) {
  GA_IS_TI = process.env.REACT_APP_GA4_IS_TI;
}

const ISRouter = () => {
    useEffect(() => {
        shopifyInit({
            token: shopifyData.token,
            domain: shopifyData.domain,
            productIds: shopifyData.productIds,
            onlineStore: false
        });
    }, [])
    
    return(
        <>
        <GACmp trackingIds={[TRACKING_ID, GA_IS_TI]} />
        <ISRooms />
        <ISMenu />
        <WSProvider eventId='ivyshop-room'>
            <VideoProvider>
            <Chat />
            </VideoProvider>
        </WSProvider> 
        { shopifyData.productIds.map((productId, i) => (
            <div key={i} id={`product-component-${productId}`}></div>
        ))}
        </>
    )
}

export default ISRouter;